// Shared â‹® menu for device cards: Settings (rename/wifi/props hub), Device Info,
// plus any card-specific extra items. Replaces the per-card menu + info dialog.

import React, { useState } from 'react';
import {
  IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Dialog, DialogTitle,
  DialogContent, Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import UpdateCodeDialog from '../../shared/UpdateCodeDialog';
import { useApp } from '../../../core/state/AppContext';
import SettingsIcon from '@mui/icons-material/Settings';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { deviceLabel } from '../../../core/devices/deviceMeta';
import DeviceSettingsDialog from './DeviceSettingsDialog';

function InfoRow({ label, value }) {
  return (
    <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, py: 0.25 }}>
      <span>{label}</span><b style={{ color: 'inherit', textAlign: 'right' }}>{String(value ?? 'â€”')}</b>
    </Typography>
  );
}

export default function DeviceCardMenu({ device, extraItems = [], onChanged }) {
  const { canUpdateFirmware } = useApp();
  const [anchor, setAnchor] = useState(null);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const uno = device.UniqueNumber;

  return (
    <>
      <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        <MenuItem onClick={() => { setSettingsOpen(true); setAnchor(null); }}>
          <ListItemIcon><SettingsIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Settings</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => { setInfoOpen(true); setAnchor(null); }}>
          <ListItemIcon><InfoOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Device Info</ListItemText>
        </MenuItem>
        {canUpdateFirmware && (
          <MenuItem onClick={() => { setUpdateOpen(true); setAnchor(null); }}>
            <ListItemIcon><SystemUpdateAltIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Update Code</ListItemText>
          </MenuItem>
        )}
        {extraItems.map((it) => (
          <MenuItem key={it.label} onClick={() => { it.onClick(); setAnchor(null); }}>
            {it.icon && <ListItemIcon>{it.icon}</ListItemIcon>}
            <ListItemText>{it.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>

      <UpdateCodeDialog
        open={updateOpen}
        scope={{ type: 'device', device, name: device?.DeviceName || device?.UniqueNumber }}
        onClose={() => setUpdateOpen(false)}
      />

      <DeviceSettingsDialog
        device={device} open={settingsOpen}
        onClose={() => setSettingsOpen(false)} onSaved={onChanged}
      />

      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>{device.DeviceName || uno}</DialogTitle>
        <DialogContent dividers>
          <InfoRow label="Unique Number" value={uno} />
          <InfoRow label="Type" value={deviceLabel(device.DeviceID)} />
          <InfoRow label="Device ID" value={device.DeviceID} />
          {device.RoomName && <InfoRow label="Room" value={device.RoomName} />}
          {device.LocationName && <InfoRow label="Location" value={device.LocationName} />}
        </DialogContent>
      </Dialog>
    </>
  );
}
